import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';
import {MainPagesContainerComponent} from '../main-pages-container/main-pages-container.component';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MainPagesContainerComponent,
        MatButtonModule,
        RouterModule,
        TranslatePipe,
        TranslateDirective
    ]
})
export class PrivacyPolicyComponent {
}
